export { default } from './BoletoV2';
